import { LoadSurgicalOrderGuides } from 'domain/usecases/surgical-order-guides/load-surgical-order-guides'
import { SurgicalOrderGuidesRepository } from 'repository/repositories/surgical-order-guides/surgical-order-guides-repository'

export class RemoteLoadSurgicalOrderGuides implements LoadSurgicalOrderGuides {
  constructor(
    private readonly surgicalOrderGuidesRepository: SurgicalOrderGuidesRepository
  ) {}
  load(
    surgical_order_id: number,
    isObservations?: boolean
  ): Promise<LoadSurgicalOrderGuides.Model> {
    if (isObservations) {
      return this.surgicalOrderGuidesRepository.loadSurgicalOrderGuidesObservations(
        surgical_order_id
      )
    }
    return this.surgicalOrderGuidesRepository.loadSurgicalOrderGuides(
      surgical_order_id
    )
  }
}
